<!-- eslint-disable vue/multi-word-component-names -- Existing component, kept for backward compatibility -->
<template>
    <div class="disclaimer">
        <p class="disclaimer-text">
            Messages in this chat are AI-generated.
            <template v-if="hasAdditionalMessage && !noModal">
                <br class="sm:hidden" />
                Remember to adhere to <button type="button" class="underline cursor-pointer" @click="openDialog()">company guidelines</button>.
            </template>
        </p>
        <MarkdownText v-if="hasAdditionalMessage && noModal" class="disclaimer-text" :text="additionalMessage" />
    </div>
    <BaseDialog v-model:open="isDialogOpen" title="Company Disclaimer">
        <div class="p-4 min-w-[300px]">
            <button type="button" aria-label="Close company disclaimer" class="absolute top-2 right-2 p-3 bi bi-x text-2xl" @click="closeDialog()" />
            <h3 class="title-subsection mb-4">Company Disclaimer</h3>
            <div class="mt-2 text-left">
                <MarkdownText class="body-small md:body-semibold" :text="additionalMessage" />
            </div>
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseDialog from "~vue/components/BaseDialog.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import { computed, ref } from "vue";

const { message = "" } = defineProps<{ message?: string }>();
const hasAdditionalMessage = computed(() => !!message);

const additionalMessage = computed(() => message?.replace("/no-modal/", "").trim());
// disclaimer message coming from organization settings in admin page can optionally have a modal to display longer messages
// when a modal is not necessary, the message will include a "/no-modal/" in the string
const noModal = computed(() => message?.includes("/no-modal/"));

const isDialogOpen = ref(false);
const openDialog = () => (isDialogOpen.value = true);
const closeDialog = () => (isDialogOpen.value = false);
</script>

<style scoped>
@reference "../../css/tailwind.css";

@layer components {
    .disclaimer {
        @apply text-center px-4 lg:px-6 lg:py-2 lg:border-2 lg:border-border lg:bg-[#FAFAFA] lg:rounded-xl;

        &:where(html[data-theme="tonal"] *) {
            @apply bg-transparent border-0;
        }
    }

    .disclaimer-text {
        @apply details lg:body-small text-valence-grey-750;

        &:where(html[data-theme="tonal"] *) {
            @apply scaffold-details-small lg:scaffold-body-small;
        }
    }
}
</style>
